import * as modal from './modal';
import * as button from './button';

$(function () {

    // アルバム作成モーダル（Submit）
    $("#createAlbum_submit").on("click", function () {
        // ボタンを無効に
        button.invalid(this);

        createAlbum(document.forms["createAlbum_Form"], this);
    });
    
});

//　新規アルバム作成
function createAlbum(formData, thisElem) {
    $.ajax({
        type: 'POST',
        url: mypath + 'home/create',
        data: $(formData).serialize(),
        dataType: 'json',
        scriptCharset: 'utf-8',
        cache: false
    })
        .then(
            function (res) {

                if (res['flag']) {

                    // リロード
                    location.reload();

                } else {
                    Swal.fire({
                        title: 'エラー',
                        text: res['error'],
                        confirmButtonText: 'OK'
                    }).then((result) => {
                        if (result.isConfirmed) {
                            // ボタンを有効に
                            button.valid(thisElem);
                        }
                    });
                }
            },
            function (XMLHttpRequest, textStatus, errorThrown) {

                // バリデーションエラー
                if (XMLHttpRequest.responseJSON.errors) {
                    for (let key in XMLHttpRequest.responseJSON.errors) {
                        Swal.fire({
                            title: '入力エラー',
                            text: XMLHttpRequest.responseJSON.errors[key][0],
                            confirmButtonText: 'OK'
                        }).then((result) => {
                            if (result.isConfirmed) {
                                // ボタンを有効に
                                button.valid(thisElem);
                            }
                        });
                        break;
                    }
                }
            });
}
